module.exports = __webpack_public_path__ + "static/media/child-care.675dd106.jpg";